import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
}                              from '@angular/common/http';
import {
	Injectable,
	OnDestroy
}                              from '@angular/core';
import { ManageTenantService } from '@core/services/manage-tenant.service';
import {
	HEADER_MANAGED_TENANT_INTERCEPTOR,
	IHeaderManagedTenantInterceptor,
	InterceptorXHeaderIdentifierEnum
}                              from '@interceptors/interceptors.model';
import { IManageTenant }       from '@shared/content-sections/manage-tenant/manage-tenant.model';
import { LoggerService }       from '@shared/services/logger.service';
import {
	Observable,
	Subject
}                              from 'rxjs';
import { takeUntil }           from 'rxjs/operators';

@Injectable()
export class XTenantInterceptor implements HttpInterceptor, OnDestroy {
	private _managedTenant: IManageTenant;
	private readonly _ngUnsubscribe: Subject<void> = new Subject();


	constructor(
		private readonly logger: LoggerService,
		private readonly manageTenantService: ManageTenantService
	) {
		this.manageTenantService.managedTenant$
		.pipe( takeUntil( this._ngUnsubscribe ) )
		.subscribe( ( managedTenant: IManageTenant ) => {
			this._managedTenant = managedTenant;
		} );
	}

	ngOnDestroy() {
		this.logger.trace( 'XTenantInterceptor ngOnDestroy' );
		this._ngUnsubscribe.next();
		this._ngUnsubscribe.complete();
	}


	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {

		const headerManagedTenantInterceptor: IHeaderManagedTenantInterceptor = req.context.get( HEADER_MANAGED_TENANT_INTERCEPTOR );

		if ( this._managedTenant ) {
			req = req.clone( { headers: req.headers.set( InterceptorXHeaderIdentifierEnum.HEADER_MANAGED_TENANT, this._managedTenant?.tenantId ) } );

			// if ( this._managedTenant?.realm ) {
			// 	req = req.clone( { headers: req.headers.set( InterceptorXHeaderIdentifierEnum.HEADER_MANAGED_TENANT_REALM, this._managedTenant?.realm ) } );
			// }
		} else if ( headerManagedTenantInterceptor?.enabled ) {
			req = req.clone( { headers: req.headers.set( headerManagedTenantInterceptor.xHeader, headerManagedTenantInterceptor.tenantId ) } );
		}

		this.logger.trace( 'XTenantInterceptor req', req );
		return next.handle( req );
	}
}
